"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasValue = exports.getFilesAttachedMaxSizeExceeded = exports.getEmailAttachmentsSize = exports.delay = exports.defaultRetry = exports.retry = exports.memoize = exports.debouncePromise = void 0;
const units_1 = require("../units");
const fs_1 = __importDefault(require("fs"));
const debouncePromise = (func, wait) => {
    let timeout;
    let lastResolve;
    let lastVal = null;
    return function cb(...args) {
        return new Promise((resolve) => {
            const context = this;
            clearTimeout(timeout);
            if (lastResolve) {
                lastResolve(lastVal);
            }
            lastResolve = resolve;
            timeout = setTimeout(() => {
                func.apply(context, args).then((val) => {
                    lastVal = val;
                    lastResolve = undefined;
                    resolve(val);
                });
            }, wait);
        });
    };
};
exports.debouncePromise = debouncePromise;
const memoize = (proc) => {
    let cache;
    return function cb() {
        cache = cache || proc();
        return cache;
    };
};
exports.memoize = memoize;
const retry = () => {
    let iteration = 0;
    let iterationNumber = 0;
    let times = [100, 200, 400, 800, 1600, 3200, 6400, 12800];
    const handlingRetries = (fn) => new Promise((resolve, reject) => {
        setTimeout(() => __awaiter(void 0, void 0, void 0, function* () {
            try {
                iteration += 1;
                resolve(yield fn());
            }
            catch (error) {
                reject(error);
            }
        }), times[iteration]);
    });
    const executeForPromise = (fn) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            return yield fn();
        }
        catch (error) {
            while (iteration <= iterationNumber) {
                try {
                    const result = yield handlingRetries(fn);
                    iteration = iterationNumber;
                    return result;
                }
                catch (iterError) {
                    if (iteration === iterationNumber) {
                        throw iterError;
                    }
                }
            }
            throw error;
        }
    });
    const waitAndRetry = (param) => {
        if (Array.isArray(param)) {
            iterationNumber = param.length;
            times = param;
        }
        else if (typeof param === "number") {
            iterationNumber = param;
        }
        return { executeForPromise };
    };
    return { waitAndRetry };
};
exports.retry = retry;
const defaultRetry = (fn) => exports.retry()
    .waitAndRetry(2)
    .executeForPromise(() => __awaiter(void 0, void 0, void 0, function* () { return fn(); }));
exports.defaultRetry = defaultRetry;
const delay = (ms) => new Promise((res) => setTimeout(res, ms));
exports.delay = delay;
const getEmailAttachmentsSize = (filesAttachment) => {
    let BTAttachmentSize = 0;
    filesAttachment.forEach((file) => {
        let size = 0;
        if (file.content) {
            size = file.content.toString().length;
        }
        else if (file.path && fs_1.default.existsSync(file.path)) {
            size = fs_1.default.statSync(file.path).size;
        }
        BTAttachmentSize += size;
    });
    return BTAttachmentSize;
};
exports.getEmailAttachmentsSize = getEmailAttachmentsSize;
const getFilesAttachedMaxSizeExceeded = (filesAttachment, emailAttachmentMBMaxSize) => {
    const btAttachmentSize = exports.getEmailAttachmentsSize(filesAttachment);
    return btAttachmentSize > units_1.fromMBToBT(emailAttachmentMBMaxSize);
};
exports.getFilesAttachedMaxSizeExceeded = getFilesAttachedMaxSizeExceeded;
const hasValue = (value) => {
    if (Array.isArray(value)) {
        return !!value.length;
    }
    return !!value;
};
exports.hasValue = hasValue;
//# sourceMappingURL=index.js.map